// extracted by mini-css-extract-plugin
export default {"simu":"Simu_simu__aKpm1","title-pic":"Simu_title-pic__ho0r4"};